/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

import { VERSION } from '../../version';
import {
  ATTR_TELEMETRY_SDK_NAME,
  ATTR_TELEMETRY_SDK_LANGUAGE,
  TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS,
  ATTR_TELEMETRY_SDK_VERSION,
} from '@opentelemetry/semantic-conventions';
import { ATTR_PROCESS_RUNTIME_NAME } from '../../semconv';

/** Constants describing the SDK in use */
export const SDK_INFO = {
  [ATTR_TELEMETRY_SDK_NAME]: 'opentelemetry',
  [ATTR_PROCESS_RUNTIME_NAME]: 'browser',
  [ATTR_TELEMETRY_SDK_LANGUAGE]: TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS,
  [ATTR_TELEMETRY_SDK_VERSION]: VERSION,
};
